import * as S from './index.style'
import { DadosCompraTerreno } from 'models/Viabilidade/DadosCompraTerreno'
import { DadosGarantias } from 'models/Viabilidade/Garantias'
import { DadosPermuta } from 'models/Viabilidade/Permuta'
import Garantias from './Garantias'
import Permuta from './Permuta'
import DespesasAcessorias from './DespesasAcessorias'
import Divider from '@material-ui/core/Divider'
import Datas from './Datas'
import Torna from './Torna'
import { DadosDatas } from 'models/Viabilidade/Datas'
import { DadosDespesasAcessorias } from 'models/Viabilidade/DespesasAcessorias'
import { TipoProjetoEnum } from 'models/Viabilidade/Enum/TipoProjetoEnum'
import { ModeloNegocioEnum } from 'models/Viabilidade/Enum/ModeloNegocioEnum'
import { CondicionantesEnum } from 'models/Viabilidade/Enum/CondicionantesEnum'
import { DadosParcela } from 'models/Viabilidade/Parcela'

export type CartaoDadosCompraTerrenoProps = {
  tipoProjeto: string
  modeloNegocio: string
  dadosCompraTerreno: DadosCompraTerreno
  dadosCompraTerrenoHandler: (novoValor: DadosCompraTerreno) => void
}

const CartaoDadosCompraTerreno: React.FC<CartaoDadosCompraTerrenoProps> = ({ tipoProjeto, modeloNegocio, dadosCompraTerreno, dadosCompraTerrenoHandler }) => {
  const dadosGarantiasHandler = (novoDadosGarantias: DadosGarantias) => {
    const novoValor = { ...dadosCompraTerreno }
    novoValor.garantias = novoDadosGarantias

    dadosCompraTerrenoHandler(novoValor)
  }

  const dadosPermutaHandler = (novoDadosPermuta: DadosPermuta) => {
    const novoValor = { ...dadosCompraTerreno }
    novoValor.permuta = novoDadosPermuta

    dadosCompraTerrenoHandler(novoValor)
  }

  const dadosTornaHandler = (novoDadosTorna: DadosParcela[]) => {
    const novoValor = { ...dadosCompraTerreno }
    novoValor.torna = novoDadosTorna

    dadosCompraTerrenoHandler(novoValor)
  }

  const dadosDatasHandler = (novoDadosDatas: DadosDatas) => {
    const novoValor = { ...dadosCompraTerreno }
    novoValor.datas = novoDadosDatas

    trocarDataParcelas(novoDadosDatas)
    dadosCompraTerrenoHandler(novoValor)
  }

  const dadosDespesasAcessoriasHandler = (novoDadosDespesasAcessorias: DadosDespesasAcessorias) => {
    const novoValor = { ...dadosCompraTerreno }
    novoValor.despesasAcessorias = novoDadosDespesasAcessorias

    dadosCompraTerrenoHandler(novoValor)
  }

  const dataPorCondicionante = (condicionante: string, dadosDatas: DadosDatas) => {
    const condicionantes: { [key: string]: Date | null } = {
      [CondicionantesEnum.DataCompra]: dadosDatas.compra,
      [CondicionantesEnum.DataAlvaraAprovacao]: dadosDatas.alvaraAprovacao,
      [CondicionantesEnum.DataAlvaraExecucao]: dadosDatas.alvaraExecucao,
      [CondicionantesEnum.DataRegistroEscritura]: dadosDatas.registroEscritura,
      [CondicionantesEnum.DataPrevisaoRi]: dadosDatas.previsaoRi,
      [CondicionantesEnum.DataPrevisaoLancamento]: dadosDatas.previsaoLancamento
    }

    return condicionantes[condicionante]
  }

  const trocarDataParcelas = (dadosDatas: DadosDatas) => {
    let parcelas = dadosCompraTerreno.torna
    parcelas = parcelas.map((parcela: DadosParcela) => {
      if (parcela.condicionante !== CondicionantesEnum.OutraData) parcela.dataBasePrimeiraParcela = dataPorCondicionante(parcela.condicionante, dadosDatas)
      if (parcela.condicionanteDataBaseCorrecao !== CondicionantesEnum.OutraData)
        parcela.dataBaseCorrecao = dataPorCondicionante(parcela.condicionanteDataBaseCorrecao, dadosDatas)
      return parcela
    })

    dadosTornaHandler(parcelas)
  }

  return (
    <S.Wrapper>
      <Datas dadosDatas={dadosCompraTerreno.datas} dadosDatasHandler={dadosDatasHandler} />
      {(tipoProjeto == TipoProjetoEnum.CondominioIncorporacao || modeloNegocio === ModeloNegocioEnum.MrvAdquirenteLote) && (
        <>
          <Divider orientation="horizontal" color="#D9DDDB" style={{ marginBottom: '40px', marginTop: '40px' }} />
          <Permuta dadosPermuta={dadosCompraTerreno.permuta} dadosPermutaHandler={dadosPermutaHandler} />
          <Divider orientation="horizontal" color="#D9DDDB" style={{ marginBottom: '40px', marginTop: '40px' }} />
          <Torna dadosTorna={dadosCompraTerreno.torna} dadosDatas={dadosCompraTerreno.datas} dadosTornaHandler={dadosTornaHandler} />
          <Divider orientation="horizontal" color="#D9DDDB" style={{ marginBottom: '40px', marginTop: '40px' }} />
          <DespesasAcessorias
            tipoProjeto={tipoProjeto}
            modeloNegocio={modeloNegocio}
            dadosDespesasAcessorias={dadosCompraTerreno.despesasAcessorias}
            dadosDespesasAcessoriasHandler={dadosDespesasAcessoriasHandler}
          />
          <Divider orientation="horizontal" color="#D9DDDB" style={{ marginBottom: '40px', marginTop: '40px' }} />
          <Garantias dadosGarantias={dadosCompraTerreno.garantias} dadosGarantiasHandler={dadosGarantiasHandler} />
        </>
      )}
    </S.Wrapper>
  )
}

export default CartaoDadosCompraTerreno
